import { render, staticRenderFns } from "./AddictiveStuffBtns.vue?vue&type=template&id=20e373b0&"
import script from "./AddictiveStuffBtns.vue?vue&type=script&lang=js&"
export * from "./AddictiveStuffBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports